import Swiper, { Navigation, Pagination } from 'swiper';
export const init = async function() {
    // configure Swiper to use modules
    Swiper.use([
        Navigation,
        Pagination
    ]);
    new Swiper('.js-lp-story-slider', {
        pagination: {
            el: '.LandingpageStory-pagination',
            dynamicBullets: true,
            type: 'bullets'
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        slidesPerView: 1
    });
};
